export default __webpack_public_path__ + "static/media/user-login-bg.d3c11e45.jpeg";